export enum PropSharingActions {}
